import Vue from 'vue'
import Router from 'vue-router'
import Index from './views/Index.vue'
import Main from './views/Main.vue'
import NewsViews from './views/NewsViews.vue'
import NewsInfo from './views/NewsInfo.vue'
import BookList from './views/BookList.vue'
import BookArtShow from './views/BookArtShow.vue'
import Show from './views/Show.vue'
import ShowM from './views/ShowM.vue'
import Inquery from './views/Inquery.vue'
import InqueryM from './views/InqueryM.vue'
import Message from './views/Message.vue'
import ExpertList from './views/ExpertList.vue'
import AllBooks from './views/AllBooks.vue'
import TuijCompany from './views/TuijCompany.vue'
import UserLogin from './views/UserLogin'
import ExamLogin from './views/ExamLogin'
import ConcantUs from './views/ConcantUs'
import CompanyDetails from './views/CompanyDetail.vue'
import inqMembers from './views/InqMember.vue'
import inqMembers_M from './views/InqMember_M.vue'
import inqueryM from './views/InqueryM.vue'
import MemberRlt from './views/MemberRlt.vue'
import CreateCert from './views/createCert.vue'
import CreateGrCert from './views/createGrCert.vue'
import SelectInq from './views/SelectInq.vue'
Vue.use(Router)
const originalReplace = Router.prototype.replace;
Router.prototype.replace = function replace(location) {
  return originalReplace.call(this, location).catch(err => err);
};
const router = new Router({
  mode: 'history',
  linkActiveClass: "",
  base: process.env.BASE_URL,
  routes: [{
    path: '/',
    name: 'index',
    component: Index,
    //redirect: "/",
    children: [
      {
        path: '/message',
        name: 'Message',
        component: Message,
      },{
        path: '/booklist/:bookId',
        name: 'BookList',
        component: BookList,
      },{
        path: '/bookartshow/:bookArtId',
        name: 'BookArtShow',
        component: BookArtShow,
      },
      {
        path: '/news/views/:plateId',
        name: 'newsviews',
        component: NewsViews,
      },{
        path: '/news/views/:plateId/:childId',
        name: 'newsviews',
        component: NewsViews,
      },
      {
        path: '/news/info/:plateId/:childId/:articleId',
        name: 'newsinfo',
        component: NewsInfo,
      },
      {
        path: '/news/info/:plateId/:articleId',
        name: 'newsinfo',
        component: NewsInfo,
      },
      {
        path:'/ConcantUs',
        name: 'ConcantUs',
        component:ConcantUs
      },{
        path:'/userlogin',
        name: 'UserLogin',
        component:UserLogin
      },{ 
        path: '/expertlist/:plateId',
        name: 'ExpertList',
        component: ExpertList,
      },{
        path: '/allbooks/:plateId',
        name: 'allbooks',
        component: AllBooks,
      },{
        path: '/tuijcompany',
        name: 'TuijCompany',
        component: TuijCompany,
      },{
        path: '/CompanyDetails',
        name: 'CompanyDetails',
        component: CompanyDetails
      },{
        path: '/selectinq',
        name: 'SelectInq',
        component:SelectInq
      },
      {
        path: '/',
        name: 'home',
        component: Main,
      }
    ]
  },{
    path: '/show',
    name: 'Show',
    component: Show,
  },{
    path: '/ExamLogin',
    name:'ExamLogin',
    component: ExamLogin
  }, {
    path: '/inquery',
    name: 'inquery',
    component: isPhone()?inqueryM:Inquery,
  }, {
    path: '/inqueryM',
    name: 'inqueryM',
    component: InqueryM,
  },
  {
    path: '/showM',
    name: 'ShowM',
    component: ShowM,
  },{
    path: '/InqMember',
    name: 'InqMember',
    component:isPhone()?inqMembers_M:inqMembers
  },{
    path: '/inqueryM',
    name: 'inqueryM',
    component:isPhone()?inqueryM:Inquery
  }
  ,{
    path: '/InqMember_M',
    name: 'InqMember_M',
    component: isPhone()?inqMembers_M:inqMembers
  },{
    path: '/MemberRlt',
    name: 'MemberRlt',
    component:MemberRlt
  }, {
    path: '/CreateGrCert',
    name: 'CreateGrCert',
    component: CreateGrCert,
  }, {
    path: '/CreateQyCert',
    name: 'CreateQyCert',
    component: CreateCert,
  }
  ]
})

// // 添加路由守卫
// router.beforeEach((to, from, next) => {
//   const isLogin = localStorage.eleToken ? true : false;
//   next();
// })
// let router = createRouter({
//   history: createWebHistory(),
//   routes,
//   linkExactActiveClass: "selected"
// })
function isPhone() {
  return null != navigator.userAgent.match(
    /(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i
  );
}
export default router;